// @ts-expect-error: Flow to TS migration.
import type { RecordOf } from "immutable"
import type Moment from "moment"

type TripPart = RecordOf<{
  // @ts-expect-error: Flow to TS migration.
  arrival: Map<{
    // @ts-expect-error: Flow to TS migration.
    when: Map<{
      // @ts-expect-error: Flow to TS migration.
      local: Moment
    }>
  }>
  // @ts-expect-error: Flow to TS migration.
  departure: Map<{
    // @ts-expect-error: Flow to TS migration.
    when: Map<{
      // @ts-expect-error: Flow to TS migration.
      local: Moment
    }>
  }>
}>

export function isLocalOverNight(part: TripPart): boolean {
  return (
    part.get("arrival").get("when").get("local").get("M") !==
      part.get("departure").get("when").get("local").get("M") ||
    part.get("arrival").get("when").get("local").get("D") !==
      part.get("departure").get("when").get("local").get("D")
  )
}

export function showDate(
  prevPart: TripPart & {
    readonly isLocalOverNight: typeof isLocalOverNight
  },
  part: TripPart & {
    readonly isLocalOverNight: typeof isLocalOverNight
  },
) {
  return (
    prevPart.get("departure").getIn(["when", "local"]).get("D") ===
      part.get("departure").getIn(["when", "local"]).get("D") && !part.isLocalOverNight()
  )
}
